// extracted by mini-css-extract-plugin
export default {"tableRow":"survey_tableRow__+HlrK","tableCell":"survey_tableCell__2Xkm+"};